import { countryCodeValues } from '@borradh-workspace/labels';
/** Maps JS (legacy) components → the shape above. */
export const fromLegacyComponents = (components) => components.map((c) => ({
    longText: c.long_name,
    shortText: c.short_name,
    types: c.types,
}));
const COUNTRY_CODES = new Set(countryCodeValues);
/** Where the house number goes AFTER the street name, and the separator. */
const NUMBER_AFTER_STREET = {
    at: ' ',
    be: ' ',
    ch: ' ',
    cz: ' ',
    de: ' ',
    dk: ' ',
    fi: ' ',
    nl: ' ',
    no: ' ',
    pl: ' ',
    se: ' ',
    es: ', ',
    it: ', ',
    pt: ', ',
};
/** Irish counties arrive as "County Cork" / "Co. Cork"; people write "Cork". */
const stripCountyPrefix = (value) => value.replace(/^(county|co\.?)\s+/i, '').trim();
const formatPostalCode = (raw, country) => {
    const value = raw.trim().replace(/\s+/g, ' ');
    if (!value)
        return '';
    const compact = value.replace(/\s/g, '').toUpperCase();
    // Eircode: routing key (3) + unique identifier (4), always with one space.
    if (country === 'ie' && /^[A-Z0-9]{7}$/.test(compact)) {
        return `${compact.slice(0, 3)} ${compact.slice(3)}`;
    }
    // UK postcodes: the inward code is always the last three characters.
    if (country === 'gb' && /^[A-Z0-9]{5,7}$/.test(compact)) {
        return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
    }
    return country === 'nl' || country === 'ca' ? value.toUpperCase() : value;
};
export function toLocationAddress(components, formattedAddress = '') {
    const find = (...types) => {
        for (const type of types) {
            const hit = components.find((c) => c.types.includes(type));
            if (hit?.longText?.trim())
                return hit;
        }
        return undefined;
    };
    const text = (...types) => find(...types)?.longText.trim() ?? '';
    const rawCountry = find('country')?.shortText?.trim().toLowerCase() ?? '';
    const country = COUNTRY_CODES.has(rawCountry)
        ? rawCountry
        : null;
    const number = text('street_number');
    const route = text('route');
    const numberAfter = country ? NUMBER_AFTER_STREET[country] : undefined;
    const street = number && route
        ? numberAfter
            ? `${route}${numberAfter}${number}`
            : `${number} ${route}`
        : route;
    const premise = text('premise');
    const subpremise = text('subpremise');
    // No street (common in rural Ireland): the building, else Google's own first
    // line — never an empty line 1 when Google clearly had an address.
    const addressLine1 = street ||
        premise ||
        text('establishment', 'point_of_interest') ||
        formattedAddress.split(',')[0]?.trim() ||
        '';
    const addressLine2 = [subpremise, street ? premise : '']
        .filter(Boolean)
        .join(', ');
    const city = country === 'gb'
        ? text('postal_town', 'locality', 'administrative_area_level_3')
        : text('locality', 'postal_town', 'sublocality_level_1', 'sublocality', 'administrative_area_level_3', 'administrative_area_level_2');
    // UK level 1 is the nation ("England"); the county is level 2.
    const county = country === 'gb'
        ? text('administrative_area_level_2')
        : country === 'ie'
            ? stripCountyPrefix(text('administrative_area_level_1', 'administrative_area_level_2'))
            : text('administrative_area_level_1', 'administrative_area_level_2');
    return {
        addressLine1,
        addressLine2,
        city,
        county,
        postalCode: formatPostalCode(text('postal_code'), country),
        country,
    };
}
//# sourceMappingURL=google-address.js.map